import fetchRequest from "./fetchRequest";
import { wvusLogger } from "../../lib";

export interface RequestEletterParams {
  campaignSourceCode: string;
  supportOfficeChildId: string;
  countryCode: string;
  eletterConfig: {
    baseUrl: string;
    endpoint: string;
    apiKey: string;
  };
  letterText: string;
  limitedTrustHandshake: string;
  limitedTrustMarker: string;
  mediaHandshake: string;
  mediaUrl: string;
  supporterNumber: string;
}

export async function requestEletter({
  campaignSourceCode,
  supportOfficeChildId,
  countryCode,
  eletterConfig,
  letterText,
  limitedTrustHandshake,
  limitedTrustMarker,
  mediaHandshake,
  mediaUrl,
  supporterNumber
}: RequestEletterParams) {
  const { baseUrl, endpoint, apiKey } = eletterConfig;
  const url = `${baseUrl}/${endpoint}?handshake=${encodeURIComponent(limitedTrustHandshake)}&identifier=${encodeURIComponent(supporterNumber)}&marker=${encodeURIComponent(limitedTrustMarker)}`;

  const apiPayload = {
    supporterNumber,
    childNumber: `${countryCode}-${supportOfficeChildId}`,
    countryCode: countryCode,
    eventSubject: "accordion/saki-v1/sendLetter",
    campaignSourceCode,
    letterText,
    handshake: limitedTrustHandshake,
    mediaUrl1: mediaUrl,
    mediaHandshake1: mediaHandshake
  };

  wvusLogger.log(
    JSON.stringify({
      description: "Sending SAK eletter request to events service",
      url,
      apiPayload
    }),
    wvusLogger.getLogLevelNames().INFO
  );

  try {
    const response = await fetchRequest(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "ocp-apim-subscription-key": apiKey
      },
      body: JSON.stringify(apiPayload),
      cache: "no-cache",
      mode: "cors",
      timeout: 15 * 1000
    });

    if (!response.ok) {
      throw new Error("Failed to send SAK eletter");
    }

    const respData = await response.json();

    if (!respData || !respData.letterId) {
      throw new Error("Invalid SAK eletter response");
    }

    return respData;
  } catch (err) {
    wvusLogger.log(
      new Error(`Failed to send SAK eletter: ${err}`),
      wvusLogger.getLogLevelNames().ERROR
    );
    console.error(err);
    return Promise.reject(err);
  }
}
